package com.milta.core.localization.translations.sq

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "Dërgesë e re",
    manualDeliverySubtitle = "Shtoni një dërgesë në itinerar",
    recipientNameLabel = "Emri i marrësit",
    addressLabel = "Adresa",
    phoneNumberLabel = "Telefoni",
    deliveryTimeLimitLabel = "Ora kufi",
    optionalSuffix = "(opsionale)",
    submitButton = "Shto dërgesën",
    saveEditedDeliveryButton = "Ruaj ndryshimin",
    deliveryCreated = "Dërgesa u shtua",
    errorRecipientNameRequired = "Emri i marrësit është i detyrueshëm",
    errorRecipientNameTooLong = "Emri është shumë i gjatë (maks. 150 karaktere)",
    errorAddressRequired = "Adresa është e detyrueshme",
    errorAddressTooLong = "Adresa është shumë e gjatë (maks. 255 karaktere)",
    errorPhoneTooLong = "Telefoni është shumë i gjatë (maks. 20 karaktere)",
    errorDuplicateDelivery = "Kjo dërgesë është tashmë në listë (i njëjti marrës dhe adresë)",
    errorRouteNotFound = "Itinerari nuk u gjet",
    errorForbidden = "Nuk keni leje të modifikoni këtë itinerar",
    errorValidation = "Ju lutemi kontrolloni fushat e plotësuara",
    errorGeneric = "Ndodhi një gabim. Provoni përsëri.",
    errorRouteNotInProgress = "Ky itinerar nuk është më në vazhdim. Nuk mund të shtohet një dërgesë.",
    unknownRecipientLabel = "I panjohur",
    driverHomeTitle = "Itinerari im",
    driverModeBadge = "Modaliteti shofer",
    routeStatusScheduled = "I planifikuar",
    routeStatusInProgress = "Në vazhdim",
    routeStatusCompleted = "I përfunduar",
    stopsCountLabel = "ndalesa",
    startRouteButton = "Fillo itinerarin",
    noRouteTitle = "Asnjë itinerar",
    noRouteSubtitle = "Asnjë itinerar nuk ju është caktuar për momentin.",
    noRoutePastSubtitle = "Asnjë itinerar nuk ju është caktuar për këtë datë.",
    routeInProgressTitle = "Itinerar në vazhdim",
    routeCompletedTitle = "Itinerar i përfunduar",
    deliveriesSectionTitle = "Dërgesat",
    addStopButton = "Shto një ndalesë",
    errorConflict = "Itinerari është nisur ose përfunduar tashmë.",
    greetingPrefix = "Përshëndetje",
    routeOfTheDayLabel = "ITINERARI I SOTËM",
    noOtherRouteLabel = "Asnjë itinerar tjetër i planifikuar",
    routeLabel = "Itinerar",
    importMenuTitle = "Importo dërgesat",
    importMenuSubtitle = "Disa mënyra të kombinueshme — zgjidhni një burim",
    importModePhotoPaperTitle = "Foto — listë letre",
    importModePhotoPaperDesc = "Fotografoni një fletë të shkruar me dorë ose të printuar",
    importModePhotoLabelTitle = "Foto — etiketë pakoje",
    importModePhotoLabelDesc = "Skanoni etiketën e ngjitur mbi një pako",
    importModePdfTitle = "Importo një PDF",
    importModePdfDesc = "Fletëdërgesa, skedar i skanuar",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Formati juaj — kolonat zbulohen automatikisht",
    importModeManualTitle = "Futje manuale",
    importModeManualDesc = "Emri, adresa, telefoni, ora limite",
    createRouteTitle = "Krijo një itinerar",
    createRouteEmptyDrivers = "Ende asnjë shofer në ekipin tuaj",
    editDeliveriesAction = "Modifiko",
    moreDeliveriesLabel = "të tjera",
    addDeliveriesAction = "Shto dërgesa",
    assignToTitle = "Cakto tek",
    optimizeRouteButton = "Optimizo itinerarin",
    createRouteButtonNoOptimize = "Krijo itinerarin",
    errorNoEnterprise = "Asnjë kompani e lidhur me llogarinë tuaj",
    errorDriverNotFound = "Shoferi nuk u gjet",
    errorNoDeliveries = "Shtoni të paktën një dërgesë përpara se të optimizoni itinerarin",
    errorOptimizationUnavailable = "Shërbimi i optimizimit është përkohësisht i padisponueshëm.",
    errorGeocodingFailed = "Disa adresa dorëzimi nuk mund të lokalizoheshin. Ndryshoni adresën dhe provoni përsëri.",
    dispatchTitle = "Optimizimi",
    optimizedSuccessTitle = "Itinerari u optimizua!",
    optimizedSuccessSubtitleSuffix = "ndalesa të renditura për itinerarin më të shkurtër",
    stopsStatLabel = "Ndalesa",
    driverAvailableStatus = "I disponueshëm",
    sendRouteButtonPrefix = "Dërgo itinerarin tek",
    errorRouteAlreadyDispatched = "Itinerari është dërguar tashmë.",
    stopDetailTitlePrefix = "Ndalesa",
    stopStatusCurrentLabel = "Në vazhdim",
    stopStatusUpcomingLabel = "E ardhshme",
    stopStatusDeliveredLabel = "U dorëzua",
    stopStatusFailedLabel = "Dështoi",
    stopRecipientLabel = "Marrësi",
    callActionLabel = "Telefono",
    noPhoneLabel = "Telefoni nuk është dhënë",
    packagesCountLabel = "pako",
    navigateButton = "Navigo",
    deadlineBeforePrefix = "Para orës",
    deadlinePastSuffix = "kaluar",
    validateStopAction = "Vlerëso këtë ndalesë",
    teamDashboardTitle = "Itineraret",
    todayDateLabel = "Sot",
    liveBadgeLabel = "Drejtpërdrejt",
    statRoutesLabel = "Itineraret",
    statDeliveriesLabel = "Dërgesat",
    statCompletedLabel = "Të përfunduara",
    teamSectionTitle = "Ekipi",
    routeStartedAtPrefix = "Filluar në",
    routeCompletedAtPrefix = "Përfunduar në",
    routeNotStartedLabel = "Ende pa filluar",
    emptyTeamRoutesTitle = "Asnjë itinerar atë ditë",
    emptyTeamRoutesSubtitle = "Asnjë shofer i ekipit nuk ka itinerar të planifikuar për këtë datë.",
    errorInvalidDate = "Datë e pavlefshme",
    routeDetailTitle = "Detajet e itinerarit",
    driverEyebrowLabel = "Shoferi",
    failedDeliveryTag = "Dërgesa dështoi",
    driverLoadingCheckTitle = "Verifikimi i ngarkimit",
    loadingCheckInstructionText = "Kontrolloni që të gjitha paketat e parashikuara janë ngarkuar në automjet përpara nisjes.",
    expectedPackagesLabel = "paketa të parashikuara për këtë itinerar",
    confirmLoadCheckboxPrefix = "Kam ngarkuar",
    confirmLoadCheckboxSuffix = "paketat e parashikuara për këtë itinerar",
    reportDiscrepancyToggleLabel = "Raporto një mospërputhje",
    discrepancyNotePlaceholder = "P.sh.: ngarkova 9 paketa në vend të 11…",
    discrepancyNoteTooLong = "Shënimi është shumë i gjatë — maksimumi 500 karaktere.",
    undeliveredStopsSectionTitle = "Paketa të pamarra — hiqni nga itinerari",
    removedStopNoticePrefix = "«",
    removedStopNoticeMiddle = "» u hoq nga itinerari — 1 ndalesë më pak",
    remainingStopsSuffix = "të mbetura",
    confirmAndStartButton = "Konfirmo dhe nis itinerarin",
    loadingOnBehalfOfLabel = "Në emër të",
    loadingExpectedLabel = "Ngarkesa e parashikuar",
    loadingQuestionTitle = "A i ngarkuat të gjitha pakot?",
    loadingAllLoadedPrefix = "Po, të gjitha",
    loadingAllLoadedSuffix = "pakot janë në bord",
    loadingIncompleteOption = "Ngarkesë e paplotë",
    loadingIncompleteHint = "Heq ndalesat përkatëse ose justifikoj",
    loadingIncompleteRemoveLabel = "Dhe/ose hiqni ndalesat e pangarkuara",
    slideToStartLabel = "Rrëshqitni për të nisur",
    completeRouteButton = "Përfundo itinerarin",
    completeRouteDialogTitle = "Të përfundojmë itinerarin?",
    completeRouteDialogPendingCountSuffix = "dërgesa nuk janë përpunuar ende",
    completeRouteDialogPendingNote = "Ato do të shënohen si të papërpunuara.",
    completeRouteDialogBody = "Ky veprim është përfundimtar: itinerari do të kalojë në statusin „I përfunduar” dhe nuk mund të modifikohet më.",
    completeRouteDialogBodyAllTreated = "Të gjitha dërgesat janë përpunuar. Itinerari do të kalojë në statusin „I përfunduar” dhe nuk mund të modifikohet më.",
    completeRouteDialogConfirm = "Përfundo",
    routeCompletedMessage = "Itinerari u përfundua.",
    stopStatusUntreatedLabel = "E papërpunuar",
    errorCompleteRouteStatusConflict = "Ky itinerar nuk mund të përfundohet në gjendjen e tij aktuale.",
    errorCompleteRoutePendingStopsConflict = "Disa dërgesa janë ende në pritje. Konfirmoni për ta përfunduar gjithsesi.",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Numri i paketave",
    newStopBadgeLabel = "E RE",
    reoptimizeResultTitle = "Itinerar i ri",
    reoptimizeSuccessTitle = "Itinerari u rioptimizua",
    reoptimizeSuccessSubtitleSuffix = "ndalesë e shtuar dhe ripozicionuar për itinerarin më të shkurtër.",
    reoptimizeFallbackTitle = "Ndalesa u shtua, rioptimizimi i padisponueshëm",
    reoptimizeFallbackSubtitle = "Shërbimi i optimizimit është përkohësisht i padisponueshëm. Ndalesa e re u shtua në fund të listës.",
    addedStatLabel = "Shtuar",
    backToRouteButton = "Kthehu në itinerar",
    routeBatchMultiDriverLink = "Ndaje mes disa shoferëve",
    routeBatchSelectTitle = "Ndaje turin",
    routeBatchDeliveriesReadyLabel = "dërgesa gati për t'u ndarë",
    routeBatchDriversSectionTitle = "Shoferët",
    routeBatchDriversSelectedSuffix = "shoferë të zgjedhur",
    routeBatchOptimizeToggleTitle = "Optimizo itinerarin",
    routeBatchOptimizeToggleHelp = "RoutaR ndan dhe rendit ndalesat sipas distancës. I çaktivizuar: ndarje e barabartë e thjeshtë sipas numrit të ndalesave, pa llogaritje itinerari.",
    routeBatchSubmitButtonPrefix = "Ndaje mes",
    routeBatchDriversWord = "shoferëve",
    routeBatchOptimizationUnavailable = "Shërbimi i optimizimit është përkohësisht i padisponueshëm. Turi nuk u krijua — kontrolloni lidhjen tuaj dhe provoni përsëri, ose çaktivizoni \"Optimizo itinerarin\" për një ndarje të thjeshtë të menjëhershme.",
    routeBatchPreviewTitle = "Pamja paraprake e ndarjes",
    routeBatchPreviewEyebrowMiddle = "dërgesa të ndara mes",
    routeBatchPreviewEyebrowSuffix = "shoferëve",
    routeBatchStopsChipSuffix = "ndalesa",
    routeBatchDistanceLabel = "Distanca",
    routeBatchDurationLabel = "Kohëzgjatja e vlerësuar",
    routeBatchDistanceNotCalculated = "E pallogaritur",
    routeBatchOptimizeDisabledBanner = "Optimizimi i çaktivizuar: ndarje e barabartë sipas numrit të ndalesave, pa llogaritje distance apo renditjeje.",
    routeBatchReoptimizeButton = "Rioptimizo",
    routeBatchDispatchButton = "Konfirmo dhe dërgo",
    errorRouteBatchAlreadyDispatched = "Ky grup turesh është dërguar tashmë te shoferët — nuk mund të ndryshohet më.",
    routeBatchDispatchedTitle = "Turet u dërguan!",
    routeBatchDispatchedSubtitleSuffix = "shoferë të njoftuar njëkohësisht, secili me turin e tij të planifikuar.",
    routeBatchStatRoutesLabel = "Turet",
    routeBatchStatDeliveriesLabel = "Dërgesat",
    routeBatchStatusLabel = "Statusi",
    routeBatchStatusDispatchedValue = "Dërguar",
    routeBatchSentAtLabel = "Dërguar më",
    routeBatchPerDriverTitle = "Detaje sipas shoferit",
    routeBatchDriverScheduledStatus = "E planifikuar",
    routeBatchBackToHomeButton = "Kthehu në fillim",
    errorTooManyDrivers = "Nuk mund të zgjidhni më shumë se 50 shoferë njëherësh.",
    errorTooManyDeliveries = "Një grup nuk mund të kalojë 500 dërgesa.",
    createRouteFabLabel = "Tur i ri",
    createOwnRouteButtonLabel = "Krijo / optimizo turin tim",
    createOwnRouteTitle = "Krijo turin tim",
    createOwnRouteDeliveriesCountSuffix = "dërgesa gati",
    stopStatusEnRouteLabel = "Në rrugë",
    yesterdayDateLabel = "Dje",
    periodPastLabel = "E kaluara",
    periodTomorrowLabel = "Nesër",
    viewRouteButton = "Shiko rrugën",
    viewButton = "Shiko",
    noRouteTomorrowTitle = "Asgjë e planifikuar për nesër",
    noRouteTomorrowSubtitle = "Planifiko një itinerar paraprakisht që ta kesh gati që në mëngjesin e nesërm.",
    planRouteButtonLabel = "Planifiko një itinerar",
    myRoutesTodayTitle = "Itineraret e tua sot",
    myRoutesTitle = "Itineraret e tua",
    weekdayShortNames = listOf("Hën", "Mar", "Mër", "Enj", "Pre", "Shtu", "Die"),
    weekdayFullNames = listOf("E hënë", "E martë", "E mërkurë", "E enjte", "E premte", "E shtunë", "E diel"),
    monthNames = listOf("janar", "shkurt", "mars", "prill", "maj", "qershor", "korrik", "gusht", "shtator", "tetor", "nëntor", "dhjetor"),
    statRoutesTodayLabel = "Itinerare sot",
    statStopsTodayLabel = "Ndalesa sot",
    statOnTimeLabel = "Në kohë sot",
    statAvgProgressLabel = "Përparim mesatar",
    inProgressSectionTitle = "Në vazhdim",
    upcomingSectionTitle = "Të ardhshme",
    doneSectionTitle = "Të përfunduara",
    seeAllLabel = "Shiko të gjitha",
    continueRouteButton = "Vazhdo itinerarin",
    detailsLinkLabel = "Detaje",
    deliveryProofTitle = "Vërteto dorëzimin",
    deliveryProofStatusSectionLabel = "Statusi i dorëzimit",
    deliveryProofPhotoSectionLabel = "Foto dëshmi",
    deliveryProofPhotoHint = "E detyrueshme për vërtetim",
    deliveryProofTakePhotoCta = "Bëj një foto",
    deliveryProofRetakePhotoCta = "Rifoto",
    deliveryProofRetakeChipLabel = "Rifoto",
    deliveryProofCommentSectionLabel = "Koment",
    deliveryProofCommentRequiredSuffix = "i detyrueshëm në rast dështimi",
    deliveryProofCommentPlaceholderOptional = "Opsionale — detaje mbi dorëzimin…",
    deliveryProofCommentPlaceholderRequired = "Shpjegoni arsyen e dështimit…",
    deliveryProofCommentRequiredError = "Kërkohet një koment në rast dështimi të dorëzimit",
    deliveryProofSubmitButton = "Vërteto dorëzimin",
    deliveryProofErrorInvalidPhoto = "Foto e palexueshme ose format i pambështetur. Rifotografoni dhe provoni përsëri.",
    deliveryProofAlreadyProcessedBanner = "Kjo ndalesë është përpunuar tashmë dhe nuk mund të ndryshohet më.",
    deliveryConfirmTitle = "Dorëzimi u vërtetua",
    deliveryConfirmSuccessTitle = "Dorëzimi u konfirmua",
    deliveryConfirmSuccessSubtitle = "Dëshmia u ruajt për këtë ndalesë.",
    deliveryConfirmFailedTitle = "Dështimi u regjistrua",
    deliveryConfirmFailedSubtitle = "Komenti dhe fotoja iu dërguan menaxherit.",
    deliveryConfirmRouteCompletedTitle = "Itinerari përfundoi!",
    deliveryConfirmRouteCompletedSubtitle = "Të gjitha ndalesat janë përpunuar.",
    deliveryConfirmValidatedAtLabel = "Vërtetuar më",
    deliveryConfirmNextStopEyebrowPrefix = "Ndalesa tjetër",
    deliveryConfirmGoToNextStopButton = "Shko te ndalesa tjetër",
    deliveryConfirmAllDoneMessage = "Kjo ishte ndalesa e fundit e itinerarit — mos harroni ta mbyllni.",
    offlineBannerTitle = "Jashtë linje",
    offlineBannerRouteSubtitle = "vlerësimet tuaja do të dërgohen sapo të kthehet rrjeti",
    offlineBannerValidateSubtitle = "do të ruhet lokalisht",
    offlineSyncingBannerTitle = "Sinkronizimi në vazhdim",
    offlineSyncingSubtitleSuffix = "dërgesa të dërguara",
    offlineRetryBannerTitle = "Sinkronizimi dështoi",
    offlineRetryBannerSubtitle = "provë e re në lidhjen e ardhshme të rrjetit",
    offlineSyncSuccessToastSuffix = "dërgesa u sinkronizuan me sukses",
    offlineQueuedBadgePendingLabel = "Në pritje të dërgimit",
    offlineQueuedBadgeSyncingLabel = "Duke u dërguar",
    offlineQueuedBadgeFailedLabel = "Dështoi — riprovim i planifikuar",
    offlineQueuedBadgeConflictLabel = "Tashmë i trajtuar diku tjetër",
    offlineDismissConflictAction = "Hiq",
    offlineValidatedLocallyAtPrefix = "vërtetuar lokalisht në",
    offlineAddStopRequiresConnectionSuffix = "(kërkon lidhje interneti)",
    deliveryProofOfflineSubmitButton = "Ruaj (sinkronizim i vonuar)",
    deliveryProofSavedLocallyTitle = "U ruajt lokalisht",
    deliveryProofSavedLocallySubtitle = "Kjo dërgesë do të dërgohet automatikisht sapo të rikthehet lidhja.",
    routeScheduledBannerTitle = "Itinerari nuk ka filluar ende",
    routeScheduledBannerSubtitle = "Filloni itinerarin për të vleftësuar një dërgesë.",
    geocodeIssueTag = "Adresa nuk u lokalizua",
    regeocodeAction = "Provo përsëri gjeolokalizimin",
    regeocodeSuccessMessage = "Adresat u përditësuan",
    dashboardTitle = "Dashboard",
    viewAllAction = "Shiko të gjitha",
    deleteRouteDialogTitle = "Të fshijmë itinerarin?",
    deleteRouteDialogMessage = "Ky itinerar do të fshihet përfundimisht. Ky veprim është i pakthyeshëm.",
    errorRouteDeleteConflict = "Fshirja nuk është e mundur: itinerari është aktualisht në vazhdim.",
    errorDriverHasActiveRoute = "Një itinerar tjetër është aktualisht në vazhdim. Përfundojeni atë përpara se të filloni këtë.",
    dashboardLiveBadge = "Drejtpërdrejt",
    routeBatchNoStopsTag = "Pa ndalesa",
    routeBatchNoStopsDialogTitle = "Shofer pa ndalesa",
    routeBatchNoStopsDialogMessage = "Të paktën një shofer nuk ka asnjë ndalesë të caktuar. Ai do të marrë gjithsesi një itinerar bosh nëse nuk hiqet nga ky grup. Dërgo gjithsesi?",
    ),
)
